import React from 'react'
import { CHART_CODES } from '../constants'

import Wrapper from './Wrapper/Wrapper'

const Users = ({ projectId, dateRange, t }) => (
    <Wrapper
        projectId={projectId}
        code={CHART_CODES.USERS}
        description={t('Number of users who interacted with the project')}
        isInteger={true}
        dateRange={dateRange}
    />
)

export default Users
